<template>
  <!-- 時間外申請詳細画面 -->
  <CCard>
    <CCardHeader>
      <h2>予定外時間外報告詳細</h2>
    </CCardHeader>
    <CCardBody>
      <CRow>
          <div class="container">
            <table class="table">
              <tr>
                <th scope="row" style="width: 170px;">申請ユーザ名</th>
                <td>
                  {{user_name}}
                </td>
              </tr>
              <tr>
                <th scope="row">申請日</th>
                <td>
                  {{ updated_at }}
                </td>
              </tr>
              <tr>
                <th scope="row">予定時間外勤務時間</th>
                <td>
                  {{ overtime }}時間
                </td>
              </tr>
              <tr>
                <th scope="row">発生理由</th>
                <td>
                  {{ reason }}
                </td>
              </tr>
            </table>      
        </div>
        </CRow>
    </CCardBody>
  </CCard>
</template>
  
<script>
  import ConstList from './../../ConstList'
  import axios from 'axios'
  export default {
    name: 'Info',
    data() {
      return {
        user_name: '',
        start_day: '',
        end_day: '',
        overtime: 0,
        updated_at: '',
        reason: ''
      }
    },
  
      // DBから各種情報を取得
    mounted: function () {
      this.id = this.$route.params.id
      const id = parseInt(this.id);
        axios
          .get((process.env.VUE_APP_API_ORIGIN) + '/overtime/' + id)
          .then(response => {
            if (response.data.length === 0) {
              this.errors.push(ConstList.EMPTY)
            }
            const overtimeData = response.data
            this.user_name = overtimeData.user_name
            this.start_day = overtimeData.start_day
            this.end_day = overtimeData.end_day
            this.overtime = overtimeData.overtime
            this.updated_at = overtimeData.updated_at
            this.reason = overtimeData.reason
                      })
          .catch(error => {
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            })
          })
    },
    methods: {
      autoTimeSet: function () {
        let start = this.start_time
        let end = this.end_time
        if (((this.start_day !== "") && (this.end_day !== "")) && (this.start_day !== this.end_day)) {
          start.splice(0, 1, ConstList.ALLDAY_ID)
          end.splice(0, 1, ConstList.ALLDAY_ID)
        }
      }
      },
    }
  </script>
  
  <style scoped>
  button:disabled {
    cursor: not-allowed;
  }
  </style>
  